import { render } from "./CalendarEdit.vue?vue&type=template&id=b43beb26&scoped=true"
import script from "./CalendarEdit.vue?vue&type=script&lang=js"
export * from "./CalendarEdit.vue?vue&type=script&lang=js"

import "./CalendarEdit.vue?vue&type=style&index=0&id=b43beb26&scoped=true&lang=css"
import "./CalendarEdit.vue?vue&type=style&index=1&id=b43beb26&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b43beb26"]])

export default __exports__